import { render, staticRenderFns } from "./ProductsCenter.vue?vue&type=template&id=0670da04&scoped=true&"
import script from "./ProductsCenter.vue?vue&type=script&lang=js&"
export * from "./ProductsCenter.vue?vue&type=script&lang=js&"
import style0 from "./ProductsCenter.vue?vue&type=style&index=0&id=0670da04&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0670da04",
  null
  
)

export default component.exports